import { useRouter } from 'next/router'
import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import AuthLayoutV2 from 'src/@core/layouts/AuthLayoutV2'
import SetPassword from 'src/components/auth/SetPassword'
import ResetPassword from 'src/components/auth/ResetPassword'
import { hasAuthCookie } from 'src/lib/utils/helpers'
import EmailConfirm from 'src/components/auth/EmailConfirm'
import EmailExpired from 'src/components/auth/EmailExpired'
import VerifyEmail from 'src/components/auth/VerifyEmail'
import EmailSent from 'src/components/auth/EmailSent'
import RecipientEmailConfirmation from 'src/components/auth/InvititationAccepted'
import LoginPageV2 from 'src/components/auth/LoginPageV2'

const Auth = () => {
  const router = useRouter()
  const { type } = router.query
  const redirectType = type ? type[0] : ''

  const allowedModes = [
    'email-confirm',
    'email-expired',
    'login',
    'reset-password',
    'set-password',
    'email-verify',
    'email-sent',
    'join-team',
    'recipient-email-confirm'
  ]

  useEffect(() => {
    if (hasAuthCookie() && redirectType === 'login') {
      router.replace('/')
      return
    }
    if (Boolean(redirectType) && !Boolean(allowedModes.includes(redirectType))) {
      router.replace('/auth/login')
      return
    }
  }, [redirectType])

  const getMainContent = useCallback(() => {
    switch (redirectType) {
      case 'email-confirm':
        return <EmailConfirm />
      case 'email-expired':
        return <EmailExpired />
      case 'login':
        return <LoginPageV2 />
      case 'reset-password':
        return <ResetPassword />
      case 'set-password':
      case 'join-team':
        return <SetPassword />
      case 'email-verify':
        return <VerifyEmail />
      case 'email-sent':
        return <EmailSent />
      case 'recipient-email-confirm':
        return <RecipientEmailConfirmation />
      default:
        return <></>
    }
  }, [redirectType])

  return <div>{getMainContent()}</div>
}

export default Auth

Auth.getLayout = (page: ReactNode) => {
  return <AuthLayoutV2>{page}</AuthLayoutV2>
}
